/* COMPONENT IMPORTS*/
import authentication from "../../msalb2creact";
import ContextConstructor from "../Context/Context";

/* MODULE IMPORTS */
import { NavLink } from "react-router-dom";
import React, { Component } from "react";

/* CSS IMPORT */
import "./Sidebar.css";
import avatarDefault from "../../images/Avatar_default.png";
import avatarExemplo from "../../images/Avatar_example.png";
import aMLogo from "../../images/AM_Logo.png";

import logoImg from "../../images/Logo.png";
import logoMobileImg from "../../images/logoMobile.png";
import bulletHomeImg from "../../images/bullet_home.png";
import bulletPoupancaImg from "../../images/bullet_poupanca.png";
import bulletProtecaoImg from "../../images/bullet_protecao.png";
import bulletBeneficiosImg from "../../images/bullet_beneficios.png";
import bulletCartaoImg from "../../images/bullet_cartao.png";
import bulletGestaoImg from "../../images/bullet_gestao_documental.png";
import bulletGestorImg from "../../images/bullet_gestor.png";
import eleicoesImg from "../../images/eleicoes.png";

class DesktopSidebar extends Component {
  static displayName = DesktopSidebar.name;

  constructor(props) {
    super(props);
    this.state = {
      //manager: [],
      //hasManager: false,
      //loading: true,
      //loadingManager: true,
    };
  }

  componentDidMount() {
    //this.populateManagerData();
    //console.log(this.state.manager);
  }

  addDefaultSrc(ev) {
    ev.target.src = avatarDefault;
  }

  static renderManagerCard(manager, sideBar) {
    return (
      <div className="manager-box">
        <div className="avatar">
          <img src={avatarDefault} alt="" width="70" height="70"></img>
        </div>
        <center className="manager-name-occupation" style={{ paddingLeft: "0px" }}>
          <div className="manager-name">{manager.name}</div>
          <div className="manager-occupation">"Gestor Mutualista"</div>
        </center>
        <button onClick={sideBar.openPopupGestor.bind(sideBar)} className="contact-popup-button">
          Contacto
        </button>
      </div>
    );
  }

  static renderNoManagerCard(sideBar) {
    return (
      <div className="manager-box">
        <div className="avatar">
          <img src={avatarExemplo} alt="" width="70" height="70"></img>
        </div>
        <center className="manager-name-occupation" style={{ paddingLeft: "0px" }}>
          <div className="manager-name" style={{ marginBottom: "15px" }}>
            Tem dúvidas?
          </div>
        </center>
        <button onClick={sideBar.openPopupGestor.bind(sideBar)} className="contact-popup-button">
          Contacto
        </button>
      </div>
    );
  }

  openPopupGestor() {
    //faz triger do click para abrir o popup pretendido
    document.getElementById("popupGestorTrigger").click();
  }

  render() {
    //console.log("DesktopSideBar Context ", this.context)

    let loading = this.props.hasManager === undefined;
    let manager = this.props.manager;
    let hasManager = this.props.hasManager && manager && manager.name && manager.name.trim() !== '';

    let contents = hasManager
      ? DesktopSidebar.renderManagerCard(manager, this)
      : DesktopSidebar.renderNoManagerCard(this);

    let gestorContactTablet = (
      <div
        onClick={this.openPopupGestor.bind(this)}
        className="link link-gestor"
        href="#"
        aria-current="page">
        <img
          src={bulletGestorImg}
          alt=""
          height="26px"
          width="26px"></img>
        <br></br>
        <span>Gestor</span>
      </div>
    );

    // Get isElectionsTime from context instead of local state
    var isElectionsTime = this.context.isElectionsTime;

    /*this.context.selectedUser.userState == "CONDICIONADO" , this.context.selectedUser.hasQuotas === true*/
    return (
      <nav className="sidebar">
        <div
          className={
            this.context.selectedUser.associateState ==
            "CONDICIONADO"
              ? "sidebar-list disabled-link"
              : "sidebar-list"
          }>
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <img
              src={logoImg}
              alt=""
              width="137px"
              height="45px"
              className="sidebar-logo"></img>
            <img
              src={logoMobileImg}
              alt=""
              height="45px"
              className="sidebar-logo-mobile"></img>
          </NavLink>
          <ul className="sidebar-links" onClick={this.props.closeMenuFunction}>
            <li>
              <NavLink exact activeClassName="active" className="link" to="/">
                <img
                  src={bulletHomeImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}> Início</span>
              </NavLink>
            </li>
           
            {isElectionsTime && (
              <li>
                <NavLink exact activeClassName="active" className="link" to="/eleicoes">
                  <img
                    src={eleicoesImg}
                    alt=""
                    height="26px"
                    width="26px"></img>
                  <span style={{ marginLeft: "10px" }}>
                    Eleição dos Órgãos <br></br> Associativos
                  </span>
                </NavLink>
              </li>
            )}
            <li>
              <NavLink exact activeClassName="active" className="link" to="/poupanca">
                <img
                  src={bulletPoupancaImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}>Poupança</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" className="link" to="/protecao">
                <img
                  src={bulletProtecaoImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}>Proteção</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" className="link" to="/beneficios">
                <img
                  src={bulletBeneficiosImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}>Programa Benefícios</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" className="link" to="/cartaoassociado">
                <img
                  src={bulletCartaoImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}>Cartão Associado</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact activeClassName="active" className="link" to="/correio">
                <img
                  src={bulletGestaoImg}
                  alt=""
                  height="26px"
                  width="26px"></img>
                <span style={{ marginLeft: "10px" }}>Correio Digital</span>
              </NavLink>
            </li>

            <li className="list-element-gestor">{gestorContactTablet}</li>
          </ul>
        </div>
        {contents}
        <div className="poweredbydiv">
          <img src={aMLogo} alt=""></img>
        </div>
      </nav>
    );
  }
  async populateManagerData() {
    setTimeout(async () => {
      this.setState({
        hasManager: this.props.hasManager,
        manager: this.props.manager,
        loadingManager: this.props.hasManager ? false : true,
        loading: this.props.hasManager ? false : true,
      });
    }, 0);
  }
}

DesktopSidebar.contextType = ContextConstructor;

export default DesktopSidebar;
